<template>
  <vx-card no-shadow>
    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="activeUserInfo.small_photo" size="70px" class="mr-4 mb-4" />
      <div>
        <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*" />
        <vs-button class="mr-4 sm:mb-0 mb-2" @click="$refs.uploadImgInput.click()">Change Gallery Picture</vs-button>

        <!-- <vs-button class="mr-4 sm:mb-0 mb-2">Upload photo</vs-button> -->
        <!-- <vs-button v-on:click="deleteUserPhoto()" type="border" color="danger">Remove</vs-button> -->
        <!-- Max size of 800kB -->
        <p class="text-sm mt-2">Allowed JPG, GIF or PNG.</p>
      </div>
    </div>

    <!-- Info -->
    <vs-input class="w-full mb-base" label-placeholder="Gallery Name" v-model="username"></vs-input>
    <vs-input class="w-full mb-base" label-placeholder="Gallery Description" v-model="description"></vs-input>

    <!-- <vs-input class="w-full mb-base" label-placeholder="Name" v-model="name"></vs-input> -->
    <vs-input class="w-full" label-placeholder="Email" v-model="email"></vs-input>
    <br />
    <vs-alert :active="isVerified" color="danger" icon-pack="feather" icon="icon-info">
      <span>Your account is not <b>verified</b>. Check your emails and click on the confirmation link.</span>
    </vs-alert>
    <br />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button v-on:click="saveUserInfoConfirm()" class="ml-auto mt-2">Save Changes</vs-button>
      <vs-button v-on:click="resetUserInfo()" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      description: JSON.parse(localStorage.getItem('layerInfo')).description,
      username: this.$store.state.AppActiveUser.username,
      email: this.$store.state.AppActiveUser.email,
      state: this.$store.state.AppActiveUser.state,
      activeLayerChangeConfirm: false,
    }
  },
  computed: {
    activeUserInfo() {
      console.log(this.$store.state.AppActiveUser.small_hoto)
      return this.$store.state.AppActiveUser
    },
    isVerified() {
      if (this.$store.state.AppActiveUser.state === 'active') {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    saveUserInfoConfirm() {
      if (this.$store.state.AppActiveUser.username !== this.username) {
        console.log('x x x x x x x x')

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Warning',
          text: 'Changing your gallery name will break all existing artwork links. Do you want to proceed ?',
          accept: this.saveUserInfo,
          cancel: this.resetUserInfo,
        })
      } else {
        this.saveUserInfo()
        this.saveLayerInfo()
      }
    },
    getUser() {
      this.$vs.loading()
      this.$store
        .dispatch('auth/getUser')
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(err => {
          console.error(err)
          this.$vs.loading.close()
        })
    },
    updateUserPhoto(photo) {
      this.$vs.loading()
      this.$store
        .dispatch('auth/updateUserPhoto', photo)
        .then(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Success',
            text: 'Gallery picture updated',
            color: 'success',
            icon: 'check_box',
          })
          console.log('SUCCESS')
        })
        .catch(err => {
          this.$vs.loading.close()
          console.error(err)
        })
    },
    deleteUserPhoto() {
      this.$vs.loading()

      this.$store
        .dispatch('auth/deleteUserPhoto')
        .then(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Icon mail',
            text: 'Photo has been deleted',
            color: 'success',
            icon: 'check_box',
          })
          console.log('SUCCESS')
        })
        .catch(err => {
          this.$vs.loading.close()
          console.error(err)
        })
    },
    resetUserInfo() {
      ;(this.description = JSON.parse(localStorage.getItem('layerInfo')).description),
        (this.username = this.$store.state.AppActiveUser.username)
      this.email = this.$store.state.AppActiveUser.email
      //this.$vs.notify({title:'Profile reset', text:'Successfull', color:'success', icon:'check_box'})
    },
    saveUserInfo() {
      const user = {
        username: this.username,
        email: this.email,
      }
      this.$vs.loading()

      this.$store
        .dispatch('auth/modifyUser', user)
        .then(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Success',
            text: 'Profile updated',
            color: 'success',
            icon: 'check_box',
          })

          console.log('SUCCESS')
        })
        .catch(err => {
          this.$vs.loading.close()
          console.error(err)
        })
    },

    saveLayerInfo() {
      const layer = {
        pid: JSON.parse(localStorage.getItem('layerInfo')).pid,
        description: this.description,
      }
      this.$vs.loading()

      this.$store
        .dispatch('auth/modifyLayer', layer)
        .then(() => {
          console.log('SUCCESS')
        })
        .catch(err => {
          console.error(err)
        })
    },

    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        this.updateUserPhoto(input.target.files[0])
      }
    },
    compressImage(base64) {
      const canvas = document.createElement('canvas')
      const img = document.createElement('img')

      return new Promise((resolve, reject) => {
        img.onload = function() {
          let width = img.width
          let height = img.height
          const maxHeight = 1000
          const maxWidth = 1000

          if (width > height) {
            if (width > maxWidth) {
              height = Math.round((height *= maxWidth / width))
              width = maxWidth
            }
          } else if (height > maxHeight) {
            width = Math.round((width *= maxHeight / height))
            height = maxHeight
          }
          canvas.width = width
          canvas.height = height

          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)

          resolve(canvas.toDataURL('image/jpeg', 0.7))
        }
        img.onerror = function(err) {
          reject(err)
        }
        img.src = base64
      })
    },
  },
}
</script>
